import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KanbanMenuInterface } from 'Interfaces/KanbanMenuInterface';

const INITIAL_STATE: KanbanMenuInterface = {
  selectedForm: ''
};

const kanbanMenuSlice = createSlice({
  name: 'kanbanMenu',
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedForm(state, action: PayloadAction<string>) {
      return { selectedForm: action.payload };
    },
  },
});
export const { setSelectedForm } = kanbanMenuSlice.actions;
export default kanbanMenuSlice.reducer;
